import $ from 'jquery';
import React from 'react';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

function DropdownButton(props) {

    useEffect(() => {
        setTimeout(function () { $('[data-toggle="dropdown"]').dropdown(); }, 10);
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked DropDown',
            label: 'Dropdown Selected for ' + props.value_attr
        });
    })

    const getLabel = (labelKey, selectedOpt, index) => {
        let fArr = labelKey.split('||');
        let label = '';
        if (fArr.length > 0) {
            for (let i = 0; i < fArr.length; i++)
                if (selectedOpt[fArr[i]]) {
                    label = selectedOpt[fArr[i]]
                    break;
                }
        } else {
            label = selectedOpt[labelKey];
        }
        return (index > 0 ? ', ' : '') + label;
    }

    let labelText = props.default;
    let selectedOpt = null;
    let opts = props.opts ? [...props.opts] : [];
    for (var opt of opts) {
        if (props.selected || props.selected === '') {
            if (props.selected === opt[props.field_attr]) {
                selectedOpt = opt;
                break;
            }
        } else {
            if (opt.default) { // This is to handle default
                selectedOpt = opt;
                break;
            }
        }
    }

    if (selectedOpt)
        labelText = props.value_attr.split(',').map((v, i) => getLabel(v, selectedOpt, i));

    if (props.maxChars && Array.isArray(labelText) && labelText[0].length > props.maxChars) {
        labelText = labelText[0].substring(0, props.maxChars);
    }

    let comp_id = 'dropdown-button-' + (Math.floor((Math.random() * 10000000) + 1));

    return (
        <div style={{ "display": "inline" }}>
            <button style={{ minWidth: props.minWidth ? props.minWidth : '100px' }} className={props.className} type="button" id={comp_id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {labelText}
            </button>
            <div className="dropdown-menu" aria-labelledby={comp_id}>
                <div className="scrollable-menu">
                    {
                        props.opts && props.opts.length > 0 && props.opts.map((opt, i) => (
                            <div key={{ comp_id } + "-" + i} className={props.selected === opt[props.field_attr] ? "dropdown-item active" : opt.disabled ? "dropdown-item disabled" : "dropdown-item"} onClick={(e) => { return opt.disabled ? false : props.onOptionClick({ ...opt }, e) }}>
                                {opt.device_type === 'Gateway' && opt.device_operstatus === 'Connected' ? <i className="fas fa-broadcast-tower text-success pr-1"></i> : opt.device_type === 'Gateway' && opt.device_operstatus === 'Disconnected' && <i className="fas fa-broadcast-tower text-danger pr-1"></i>}
                                {props.value_attr.split(',').map((v, i) => getLabel(v, opt, i))}
                            </div>
                        ))
                    }
                </div>
                {
                    props.dropdown_footer
                }
            </div>
        </div>
    );
}

export default DropdownButton;